import type * as T from './index-types';

export const init: T.Init = function () {
  // Nothing
};

export const send: T.Send = function () {
  // Nothing
};

export const getNumClients: T.GetNumClients = function () {
  return 1;
};
